import React from "react"

const Footer = () => (
  <footer>
    <section>
      <p>
        © Ryan James O'Shea {new Date().getFullYear()}, <br />
        Built with{` `}
        <a href="https://www.gatsbyjs.org">Gatsby</a>
      </p>
    </section>
  </footer>
)

export default Footer
